import React, { type FC } from 'react'

import {
    Capability,
    createIsAuthenticatedWithCapabilitiesSelector,
    type CybusVolume,
    selectLoadedVolumes,
    selectVolumesPage,
    type StatusType,
    Translation,
} from '../../../domain'

import { Status, useClearTableSelection } from '../common'
import { useTranslator } from '../Internationalization'
import { RedirectingResourcesTable } from '../Resources'
import { RelativeRoutePathWithId } from '../routing'
import { DeleteModal } from './Bulk'

const Modals: FC = () => {
    const clear = useClearTableSelection()
    return <DeleteModal volumeSelector={selectLoadedVolumes} onConfirmed={clear} />
}

const selectCanManageVolumes = createIsAuthenticatedWithCapabilitiesSelector(Capability.VOLUMES_MANAGE)

export const Table: FC<Readonly<{ serviceId?: string }>> = ({ serviceId = null }) => {
    const translator = useTranslator()

    const customCellRender = (status: StatusType): JSX.Element => <Status status={status} />

    return (
        <RedirectingResourcesTable<'manageVolumesUsecase', CybusVolume, CybusVolume, 'bulkDeleteVolumesUsecase'>
            subscriptionUsecase="manageVolumesUsecase"
            filter={serviceId ? { service: serviceId } : undefined}
            data={selectVolumesPage}
            hasManagementCapabilitiesSelector={selectCanManageVolumes}
            dataTableMapper={(volumes) => volumes}
            columns={{
                ...(serviceId ? {} : { service: { label: Translation.SERVICE_ID, sort: true } }),
                name: { label: Translation.NAME, sort: true },
                created: {
                    label: Translation.CREATED_AT,
                    customCellRender: (date) => translator.formatTranslation(Translation.DATETIME, { type: 'datetime', date }),
                    sort: true,
                    type: 'datetime',
                },
                status: { label: Translation.STATUS, customCellRender, sort: true },
            }}
            short={Boolean(serviceId)}
            redirectOnRowclick={RelativeRoutePathWithId.VOLUME}
            selection={{ DELETE: { usecase: 'bulkDeleteVolumesUsecase' }, resource: 'id', usecaseMethod: 'selectVolumes' }}
            translations={{ emptyTable: Translation.NO_VOLUMES_AVAILABLE, paginationDataType: 'VOLUME' }}
        >
            <Modals />
        </RedirectingResourcesTable>
    )
}
